import React from 'react';

export default function RazorpayBadge(){
    return (
        <a href="https://razorpay.com/" target="_blank" without="true" rel="noopener noreferrer">
            <img referrerPolicy="origin" src = "https://badges.razorpay.com/badge-dark.png " 
            style = {{height: "45px", width: "113px", borderRadius: "7px"}} alt = "Razorpay | Payment Gateway | Neobank"/>
        </a>
    )
}